export const nfseLinkErrorMappings = {
    NFSE_LINK_NFSE_CANCELLED_OR_ERROR: {
        code: 'NFSE_LINK_NFSE_CANCELLED_OR_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não é possível vincular uma NFS-e cancelada ou com erro.',
            },
            {
                language: 'pt-BR',
                message: 'Não é possível vincular uma NFS-e cancelada ou com erro.',
            },
            {
                language: 'en-US',
                message: 'Cannot link a cancelled or errored NFS-e.',
            },
            {
                language: 'es-ES',
                message: 'No es posible vincular una NFS-e cancelada o con error.',
            },
        ],
        technicalMessage: 'Não é possível vincular uma nota fiscal cancelada ou com erro',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_ALREADY_LINKED: {
        code: 'NFSE_LINK_ALREADY_LINKED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Esta NFS-e já está vinculada a uma cobrança.',
            },
            {
                language: 'pt-BR',
                message: 'Esta NFS-e já está vinculada a uma cobrança.',
            },
            {
                language: 'en-US',
                message: 'This NFS-e is already linked to a billing.',
            },
            {
                language: 'es-ES',
                message: 'Esta NFS-e ya está vinculada a un cobro.',
            },
        ],
        technicalMessage: 'Esta nota fiscal já está vinculada a uma cobrança',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_BILLING_CANCELLED_OR_ERROR: {
        code: 'NFSE_LINK_BILLING_CANCELLED_OR_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não é possível vincular a uma cobrança cancelada ou com erro.',
            },
            {
                language: 'pt-BR',
                message: 'Não é possível vincular a uma cobrança cancelada ou com erro.',
            },
            {
                language: 'en-US',
                message: 'Cannot link to a cancelled or errored billing.',
            },
            {
                language: 'es-ES',
                message: 'No es posible vincular a un cobro cancelado o con error.',
            },
        ],
        technicalMessage: 'Não é possível vincular a nota fiscal a uma cobrança cancelada ou com erro',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_BILLING_HAS_ACTIVE_NFSE: {
        code: 'NFSE_LINK_BILLING_HAS_ACTIVE_NFSE',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Esta cobrança já possui uma NFS-e ativa vinculada.',
            },
            {
                language: 'pt-BR',
                message: 'Esta cobrança já possui uma NFS-e ativa vinculada.',
            },
            {
                language: 'en-US',
                message: 'This billing already has an active linked NFS-e.',
            },
            {
                language: 'es-ES',
                message: 'Este cobro ya tiene una NFS-e activa vinculada.',
            },
        ],
        technicalMessage: 'A cobrança já possui uma nota fiscal emitida ou em processamento',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_NFSE_NOT_FOUND: {
        code: 'NFSE_LINK_NFSE_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'NFS-e não encontrada.',
            },
            {
                language: 'pt-BR',
                message: 'NFS-e não encontrada.',
            },
            {
                language: 'en-US',
                message: 'NFS-e not found.',
            },
            {
                language: 'es-ES',
                message: 'NFS-e no encontrada.',
            },
        ],
        technicalMessage: 'Nota fiscal não encontrada',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_BILLING_NOT_FOUND: {
        code: 'NFSE_LINK_BILLING_NOT_FOUND',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Cobrança não encontrada.',
            },
            {
                language: 'pt-BR',
                message: 'Cobrança não encontrada.',
            },
            {
                language: 'en-US',
                message: 'Billing not found.',
            },
            {
                language: 'es-ES',
                message: 'Cobro no encontrado.',
            },
        ],
        technicalMessage: 'Cobrança não encontrada',
        severity: 'warning',
        critical: false,
    },
    NFSE_BILLINGS_FOR_LINK_MISSING_CPF_CNPJ: {
        code: 'NFSE_BILLINGS_FOR_LINK_MISSING_CPF_CNPJ',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'CPF/CNPJ é obrigatório para buscar cobranças.',
            },
            {
                language: 'pt-BR',
                message: 'CPF/CNPJ é obrigatório para buscar cobranças.',
            },
            {
                language: 'en-US',
                message: 'CPF/CNPJ is required to search billings.',
            },
            {
                language: 'es-ES',
                message: 'CPF/CNPJ es obligatorio para buscar cobros.',
            },
        ],
        technicalMessage: 'CPF/CNPJ é obrigatório para buscar cobranças',
        severity: 'warning',
        critical: false,
    },
    NFSE_BILLINGS_FOR_LINK_INVALID_AMOUNT: {
        code: 'NFSE_BILLINGS_FOR_LINK_INVALID_AMOUNT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O valor informado para filtro é inválido.',
            },
            {
                language: 'pt-BR',
                message: 'O valor informado para filtro é inválido.',
            },
            {
                language: 'en-US',
                message: 'The filter value is invalid.',
            },
            {
                language: 'es-ES',
                message: 'El valor informado para el filtro es inválido.',
            },
        ],
        technicalMessage: 'O valor informado para filtro é inválido',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_MISSING_NFSE_ID: {
        code: 'NFSE_LINK_MISSING_NFSE_ID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'ID da NFS-e é obrigatório.',
            },
            {
                language: 'pt-BR',
                message: 'ID da NFS-e é obrigatório.',
            },
            {
                language: 'en-US',
                message: 'NFS-e ID is required.',
            },
            {
                language: 'es-ES',
                message: 'El ID de la NFS-e es obligatorio.',
            },
        ],
        technicalMessage: 'ID da NFS-e é obrigatório',
        severity: 'warning',
        critical: false,
    },
    NFSE_LINK_MISSING_BILLING_ID: {
        code: 'NFSE_LINK_MISSING_BILLING_ID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'ID da cobrança é obrigatório.',
            },
            {
                language: 'pt-BR',
                message: 'ID da cobrança é obrigatório.',
            },
            {
                language: 'en-US',
                message: 'Billing ID is required.',
            },
            {
                language: 'es-ES',
                message: 'El ID del cobro es obligatorio.',
            },
        ],
        technicalMessage: 'ID da cobrança é obrigatório',
        severity: 'warning',
        critical: false,
    },
};
